import type { PaletteCode, PaletteInfo } from '../../types'
import { isDefined } from '../guards'

export const PALETTE_CODE_ORDER: PaletteCode[] = [
  'FaintRainbow',
  'StandardSeismic',
  'BlackAndWhiteSeismic',
  'Coherence',
]

export const sortPalettes = (palettes: PaletteInfo[], palleteCodeOrder: PaletteCode[] = PALETTE_CODE_ORDER) => {
  const orderedPalettes = palleteCodeOrder
    .map(paletteCode => palettes.find(palette => palette.code === paletteCode))
    .filter(isDefined)

  const sortedPalletes = palettes
    .filter(palette => !palleteCodeOrder.includes(palette.code))
    .sort((first, second) => first.name.localeCompare(second.name))

  return [...orderedPalettes, ...sortedPalletes]
}